import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

/**agregar el llamao a las funciones que se comunican con la api */
function* asyncPostContactUs({ payload }) {
    try {
        var response = yield call(API.postContactUs, payload);
        if (response)
            yield put({
                type: actionTypes.SUCCESS_POST_CONTACT_US,
                response,
                message: ''
            });
    } catch (error) {
        yield put({
            type: actionTypes.FAILURE_POST_CONTACT_US,
            message: error.message,
        });
    }
}

export default function* contactUsSaga() {
    yield takeLatest(actionTypes.POST_CONTACT_US, asyncPostContactUs);

}